"use client"

import Box from "@mui/material/Box"
import Grid from "@mui/material/Grid"
import { ProductCardSkeleton } from "@src/components"
import { PRODUCT_PAGE_SIZE } from "@src/constants/category"

type Props = {
  count?: number
}

/** Grid of product card skeletons for category/filter/page transitions. */
export default function ProductListSkeleton({
  count = PRODUCT_PAGE_SIZE
}: Props) {
  return (
    <Grid
      container
      spacing={{
        xs: 1,
        md: 3
      }}
      sx={{
        marginLeft: {
          xs: "-8px",
          md: "-24px"
        },
        width: "100%"
      }}
    >
      {Array.from({ length: count }).map((_, index) => (
        <Grid key={index} item xs={6} lg={3}>
          <Box width="100%">
            <ProductCardSkeleton />
          </Box>
        </Grid>
      ))}
    </Grid>
  )
}
